import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  box: {
    margin: '55px 20px 20px',
    padding: '26px 20px',
    background: '#fff',
    fontFamily: 'roboto-medium',
    borderRadius: 20,
    boxShadow: '0 0 6px rgba(0, 0, 0, 0.35)'
  },
  text: {
    textAlign: 'center',
    fontSize: 24,
    color: '#697683'
  }
}));

function AnalyzeMobileSection(props: any) {
  const { page } = props;
  const classes = useStyles();
  return (
    <div className={classes.box}>
      <div className={classes.text}>
        This {page ? 'page' : 'tab'} is too complex to render on Mobile. <br /><br />
        We recommend logging back in on a device with a larger screen for a fuller experience.
      </div>
    </div>
  );
}

export default AnalyzeMobileSection;
